import { Injectable, NgModule } from "@angular/core";
import {
  Routes,
  RouterModule,
  CanActivate,
  ActivatedRouteSnapshot,
  GuardResult,
  MaybeAsync,
  RouterStateSnapshot,
  Router,
} from "@angular/router";
import { OverViewComponent } from "./overview.component";
import { Layouts } from "../app.component";
import { UserDetailsService } from "../login/services/UserDetails.service";
import { ConfigService } from "../utils/config.service";

@Injectable()
export class ActivateOverviewPage implements CanActivate {
  private role = ConfigService.settings.role;

  constructor(private userDetailsService: UserDetailsService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): MaybeAsync<GuardResult> {
    return true;
  }
}

const routes: Routes = [
  {
    path: "overview",
    component: OverViewComponent,
    data: { layout: Layouts.SecureLayout },
    canActivate: [ActivateOverviewPage],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [UserDetailsService, ActivateOverviewPage],
})
export class OverviewRoutingModule {}
